import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { actionInventoryInfoRemoveResource } from "../../inventory/actionInventoryInfo";
import { actionPlayerInfoAddXp } from "../../player/actionPlayerInfo";
import { actionProductionAdd } from "../actionProductionInfo";
export var pathProductionStart = function (action, state$, deps) {
    var state = state$.value;
    return deps
        .netSend({
        id: CommandCode.StartProduce,
        props: {
            amount: action.amount,
            buildingId: action.buildingId,
            farmId: state.playerBase.base.baseId,
            playerId: state.playerInfo.playerId,
            recipeId: action.recipeId,
        },
    })
        .pipe(retry(), switchMap(function (res) {
        return from([
            actionInventoryInfoRemoveResource(res.cost),
            actionPlayerInfoAddXp(res.xp),
            actionProductionAdd(res.buildingId, res.production),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/production/path/pathProductionStart.ts
// module id = 837
// module chunks = 3